<script setup>
import GeneralAnalysis from '@/components/analysis/GeneralAnalysis.vue';
import AnalysisBoundService from '@/components/analysis/AnalysisBoundService.vue';
import { analysisServiceForMenu } from '@/composables/saju-insight/useAnalysisSajuContext';
import { useAnalysisStore } from '@/store/modules/analysis';

definePage({ meta: { layout: 'analysis' } });
const route = useRoute();
const router = useRouter();
const store = useAnalysisStore();
const service = computed(() => analysisServiceForMenu(store.selectedMenu));
watch([() => route.params.id, service], () => store.resetAnalysisContext(route.params.id), { immediate: true, flush: 'sync' });
onBeforeUnmount(() => store.resetAnalysisContext());

watch(() => route.query.menu, (menu) => {
  if (typeof menu === 'string' && menu.startsWith('/')) store.clickMainMenu(menu);
  else if (!store.selectedMenu) store.resetSelectedMenu();
}, { immediate: true, flush: 'sync' });

watch(() => store.selectedMenu, (menu, oldMenu) => {
  if (!menu || route.query.menu === menu || !route.path.startsWith('/analysis/')) return;
  const query = { ...route.query, menu };
  if (analysisServiceForMenu(menu) !== analysisServiceForMenu(oldMenu) || menu.startsWith('/overview')) {
    delete query.analysisLogId;
  }
  router.push({ path: route.path, query });
});

onMounted(() => {
  if (!route.query.menu) router.replace({ path: route.path, query: { ...route.query, menu: store.selectedMenu } });
});
</script>

<template>
  <AnalysisBoundService
    v-if="service"
    :key="`${route.params.id}:${service}`"
    :saju-id="route.params.id"
    :service="service"
  />
  <GeneralAnalysis v-else :key="route.params.id" />
</template>
